const genres = [
  { icon: 'ri-vip-diamond-line', label: '貴金属・宝石', desc: '金・プラチナ・ダイヤモンド・指輪・ネックレスなど' },
  { icon: 'ri-handbag-line', label: 'ブランド品', desc: 'ルイヴィトン・シャネル・エルメス・グッチなど' },
  { icon: 'ri-camera-line', label: 'カメラ・レンズ', desc: 'デジタル一眼・フィルムカメラ・交換レンズなど' },
  { icon: 'ri-goblet-line', label: 'お酒', desc: 'ウイスキー・ワイン・日本酒・ブランデーなど' },
  { icon: 'ri-ticket-line', label: '金券・商品券', desc: '百貨店券・ギフト券・図書カードなど' },
  { icon: 'ri-ancient-gate-line', label: '骨董品・美術品', desc: '掛け軸・陶磁器・絵画・茶道具など' },
  { icon: 'ri-tv-line', label: '家電製品', desc: 'テレビ・冷蔵庫・洗濯機・エアコンなど' },
  { icon: 'ri-music-line', label: '楽器', desc: 'ギター・ピアノ・管楽器・打楽器など' },
  { icon: 'ri-tools-line', label: '電動工具', desc: 'マキタ・日立・ボッシュなどのブランド工具' },
  { icon: 'ri-gamepad-line', label: 'ゲーム', desc: 'ゲーム機本体・ソフト・周辺機器など' },
  { icon: 'ri-smartphone-line', label: 'スマホ・タブレット', desc: 'iPhone・iPad・Android端末など' },
  { icon: 'ri-time-line', label: '時計', desc: 'ロレックス・オメガ・カルティエなど高級時計' },
];

export default function TenjinServices() {
  return (
    <section id="genres" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col items-center text-center mb-16">
          <span className="text-xs tracking-[0.3em] text-amber-600 font-medium uppercase mb-3">Buy Items</span>
          <h2 className="text-4xl md:text-5xl font-serif text-gray-900 mb-4">取扱ジャンル</h2>
          <div className="w-16 h-0.5 bg-amber-400/50 mx-auto mb-6"></div>
          <p className="text-sm text-gray-500 max-w-xl leading-relaxed">
            福岡市・福岡県全域への<strong className="text-gray-700">出張買取</strong>に対応。
            貴金属からブランド品まで、幅広いジャンルを高価買取いたします。
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {genres.map((g) => (
            <div
              key={g.label}
              className="bg-amber-50/60 rounded-xl p-5 flex flex-col gap-3 hover:bg-amber-50 transition-colors duration-200 group"
            >
              <div className="w-10 h-10 flex items-center justify-center bg-amber-100 rounded-full group-hover:bg-amber-200 transition-colors">
                <i className={`${g.icon} text-amber-700 text-lg`}></i>
              </div>
              <div>
                <p className="text-sm font-semibold text-gray-800 mb-1">{g.label}</p>
                <p className="text-xs text-gray-500 leading-relaxed">{g.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-amber-50 rounded-2xl p-8 flex flex-col md:flex-row items-center gap-6">
          <div className="w-12 h-12 flex items-center justify-center bg-amber-100 rounded-full flex-shrink-0">
            <i className="ri-question-line text-amber-700 text-xl"></i>
          </div>
          <div className="flex-1 text-center md:text-left">
            <p className="text-sm font-semibold text-gray-800 mb-1">上記以外のお品物もお気軽にご相談ください</p>
            <p className="text-xs text-gray-500">掲載していないジャンルでも対応できる場合があります。まずはLINEまたはお電話でご相談ください。</p>
          </div>
          <a
            href="https://lin.ee/OGQq9z6"
            target="_blank"
            rel="noopener noreferrer"
            className="flex-shrink-0 inline-flex items-center gap-2 bg-[#06C755] text-white px-6 py-3 rounded-full text-sm font-medium whitespace-nowrap hover:bg-[#05b34c] transition-colors cursor-pointer"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-line-fill text-sm"></i>
            </div>
            LINEで相談する
          </a>
        </div>
      </div>
    </section>
  );
}
